module.exports = __webpack_public_path__ + "static/media/GatrPic4Site.44257f76.jpeg";